import { memo } from "react";

import DatabaseDropdown from "components/Organisms/DatasetsMenu/DatabaseDropdown";
import NotFoundText from "components/Atoms/NotFoundText";
import LoadingText from "components/Atoms/LoadingText";

import { useDatabases } from "hooks/databases/useDatabases";

import { StyledWrapper, StyledTitle } from "./styles";
import { neededArr } from "utils/data/validate";
import { ZDatabaseSchema } from "zod/database";
import { Button } from "antd";

interface DatasetsMenuProps {
  visible?: boolean;
}

const DatasetsMenu = memo(({ visible = false }: DatasetsMenuProps) => {
  const databases = useDatabases();

  return (
    <StyledWrapper
      className="flex flex-col overflow-visible"
      $visible={visible}>
      <StyledTitle className="databases-title">Databases</StyledTitle>

      <div className="overflow-auto min-h-full py-[20px]">
        {!databases?.res?.length && databases?.isLoading && (
          <LoadingText subject="Databases" />
        )}

        {!databases?.res?.length && !databases?.isLoading && (
          <NotFoundText subject="Databases" />
        )}

        {databases?.res?.map(({ name, id }: ZDatabaseSchema) => {
          neededArr([name, id], "Missing database name or id");
          return <DatabaseDropdown displayName={name!} key={id} id={id!} />;
        })}
        {databases?.paging?.after && (
          <Button
            onClick={() => {
              databases.setloadMore(!databases.loadMore);
            }}
            loading={databases.isLoading}>
            Load More
          </Button>
        )}
      </div>
    </StyledWrapper>
  );
});

export default DatasetsMenu;
